import React from "react";
import { BaseImg } from "./BaseImg";
import { ResponsiveImg } from "./ResponsiveImg";
export const Img = ({ src, alt, className, style, loading = "lazy", onError, onClick, srcset, sizes, sources, }) => (React.createElement(ResponsiveImg, { sources: sources },
    React.createElement(BaseImg, { src: src, alt: alt, className: className, style: style, loading: loading, onError: onError, onClick: onClick, srcset: srcset, sizes: sizes })));
